var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"tw-text-sm tw-font-semibold tw-leading-6 tw-text-gray-900",class:_vm.textColor},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }